<template>
    <div class="container-top">
        <div class="container-center max">
            <page-header></page-header>
            <div class="container-main gray pa0">
                <div class="box-partner-write">
                    <div class="title-partner-write">{{ returnPartnerType() }} 콘텐츠 파트너 정보 수정</div>
                    <partner-write-component :initType="partnerType" :partner-type="`updateMedia`"
                                             v-if="partnerType === 'media'"></partner-write-component>
                    <partner-write-component :initType="partnerType" :partner-type="`updateShopping`"
                                             v-if="partnerType === 'shopping'"></partner-write-component>
                    <partner-write-component :initType="partnerType" :partner-type="`updateAdvertisement`"
                                             v-if="partnerType === 'advertisement'"></partner-write-component>
                </div>
                <page-footer></page-footer>
            </div>
        </div>

        <router-view></router-view>
        <daum-postcode-modal></daum-postcode-modal>
    </div>
</template>

<script>

import PartnerWriteComponent from "@/components/partner/PartnerWriteComponent.vue";
import DaumPostcodeModal from "@/components/modal/DaumPostcodeModal.vue";
import PageFooter from "@/components/PageFooter.vue";

export default {
    name: "PartnerChange",
    mixins: [],
    components: {PageFooter, DaumPostcodeModal, PartnerWriteComponent},
    inject: [],
    provide() {
        return {};
    },
    props: {},
    data() {
        return {
            partnerType: this.$route.params.type,
        };
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        returnPartnerType() {
            if (this.partnerType === 'media') {
                return "영상"
            } else if (this.partnerType === 'shopping') {
                return "쇼핑"
            } else if (this.partnerType === 'advertisement') {
                return "광고"
            }
        },
    },
    watch: {}
};
</script>
